var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v(_vm._s(_vm.$tf('people_count'))+": "+_vm._s(_vm.item.body_count))]),_c('div',[_vm._v(_vm._s(_vm.$tf('area_records_created_date'))+": "+_vm._s(_vm.computeFormattedDate(_vm.item.created_date)))])])}
var staticRenderFns = []

export { render, staticRenderFns }